import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppAuthService } from '../auth/app-auth-service';
import { LocalStorageService } from '../../services/local-storage.service';

/** Only skip to /point-of-sale when a terminal is already picked — else a freshly Keycloak-authenticated user with no terminal loops forever bouncing between the two routes. */
export const loginGuard: CanActivateFn = (_route, _state) => {

  const router = inject(Router);
  const authService = inject(AppAuthService);
  const localStorageService = inject(LocalStorageService);

  if (authService.isLoggedIn() && localStorageService.getTerminal()) {
    return router.parseUrl('/point-of-sale');
  }

  return true;
};
